export default __webpack_public_path__ + "static/media/pyramide_carouseel.3429bc02.jpg";